var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4998 2.79199C6.24264 2.79199 2.7915 6.24313 2.7915 10.5003C2.7915 14.7575 6.24264 18.2087 10.4998 18.2087C14.757 18.2087 18.2082 14.7575 18.2082 10.5003C18.2082 6.24313 14.757 2.79199 10.4998 2.79199ZM1.5415 10.5003C1.5415 5.55277 5.55229 1.54199 10.4998 1.54199C15.4474 1.54199 19.4582 5.55277 19.4582 10.5003C19.4582 15.4479 15.4474 19.4587 10.4998 19.4587C5.55229 19.4587 1.5415 15.4479 1.5415 10.5003ZM10.1084 7.55838C10.3525 7.80246 10.3525 8.19819 10.1084 8.44227L8.67539 9.87533H13.8332C14.1783 9.87533 14.4582 10.1551 14.4582 10.5003C14.4582 10.8455 14.1783 11.1253 13.8332 11.1253H8.67539L10.1084 12.5584C10.3525 12.8025 10.3525 13.1982 10.1084 13.4423C9.86437 13.6863 9.46864 13.6863 9.22456 13.4423L6.72456 10.9423C6.48048 10.6982 6.48048 10.3025 6.72456 10.0584L9.22456 7.55838C9.46864 7.31431 9.86437 7.31431 10.1084 7.55838Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowCircle);
export default __webpack_public_path__ + "static/media/ArrowCircle.14b18926b99743b643595d91a371d011.svg";
export { ForwardRef as ReactComponent };